import type { FaireProductEntity } from "../../entity_types/product";

export const p_yfcrec2539: FaireProductEntity = {
  token: "p_yfcrec2539",
  type: "product",
  name: "WWJD Paradise Bracelet Pack",
  brandToken: "b_71tesjzfzj",
  brandName: "Elevated Faith",
  imageUrl:
    "https://cdn.faire.com/fastly/b2114d1729fac30878380be6da366e4236fa093e408ce2a9cd32fa0ac7981e46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1998d80017df548d36c6cc0c29a718b87345b46f2edd145d7452bb1e6952e5c.jpeg",
    "https://cdn.faire.com/fastly/c76d7f5ce10695629905ae2437ae43338eb3f99776fd5f5e1493872a1846d012.jpeg",
    "https://cdn.faire.com/fastly/38f2d59bc32899b520f6a779cfd2190030b204d5dd28e8e2515be5f2df4f020e.jpeg",
    "https://cdn.faire.com/fastly/228262091da993f2083b9ed9e4aa8fb07707a93147da55093b14e6f4c06d077d.jpeg",
    "https://cdn.faire.com/fastly/9dc463a223bfbafb7d614d7f042b0e827e6424c76b7685ce72d0c426e941d6dd.jpeg",
    "https://cdn.faire.com/fastly/b4bffce2e303be78ff0599e66f455720cda04b7ca72fcbf206cbc9672255b2d2.jpeg",
    "https://cdn.faire.com/fastly/0ae766ac6241cba607b5a466269fd89af5fb94dc530a6a8d2a4c45ec7fae2769.jpeg",
    "https://cdn.faire.com/fastly/a5136887937f6925fd5012ff1f09a4e854a2d601572029fbea66d3b4f232d94e.jpeg",
    "https://cdn.faire.com/fastly/0957bd71c437b3cbd2f6709eb99b95e1957fd2b165ea8b732f58a97d6a98acd1.jpeg",
  ],
  priceDollars: 8.22,
  description:
    '\nThe classic WWJD bracelet (What would Jesus do?) you grew up with. This pack includes 6 WWJD bracelets in the Paradise colorway that are fully adjustable to fit any wrist size.\n\n"For to this you have been called, because Christ also suffered for you, leaving you an example, so that you might follow in his steps." -1 Peter 2:21\n',
  tags: [],
  msrpDollars: 27.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:54.738Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
